import type { EmailAddress } from './email-address.type.ts';
export interface EmailAddressExtension extends EmailAddress {}
export class EmailAddressExtension {
  get isPersonal() {
    return this.contactType === 'PERSONAL';
  }

  /** In use: neither deleted nor a former address kept as history. */
  get isCurrent() {
    return this.isActive && !this.supersededAt;
  }
}

const Registration = {
  kind: 'object',
  name: 'email-address',
  features: EmailAddressExtension,
};
export default Registration;
